export interface SpinnerDataActionTypes {
  type: SpinnerDataActions;
  payload?: any;
}

export enum SpinnerDataActions {
  GET_SPINNER_DATA = "GET_SPINNER_DATA",
  SET_SPINNER_DATA = "SET_SPINNER_DATA",
}
